import { Map } from "immutable";
import { ofType } from "redux-observable";
import { withLatestFrom, map } from "rxjs/operators";
import createResources from "../util/createReducer";

const SELECT_RESOURCE = "vgde/map-interactions/select-resource";
const SELECT_RESOURCE_POPULATED =
  "vgde/map-interactions/select-resource-populated";
const CLEAR_RESOURCE = "vgde/map-interactions/clear-resource";

const initialState = Map();
export default createResources(initialState, {
  [SELECT_RESOURCE_POPULATED]: (state, action) => {
    const { payload } = action;
    return state.set("selectedResource", payload);
  },
  [CLEAR_RESOURCE]: state => state.delete("selectedResource")
});

export function selectResource(id) {
  return {
    type: SELECT_RESOURCE,
    payload: {
      id
    }
  };
}

export function clearResource() {
  return {
    type: CLEAR_RESOURCE
  };
}

export const populateResourceEpic = (action$, store$) =>
  action$.pipe(
    ofType(SELECT_RESOURCE),
    withLatestFrom(store$),
    map(([action, store]) => {
      const { data } = store;
      const {
        payload: { id }
      } = action;
      const stats = data.get("data").get(id);
      const props = data.get("names").get(id);
      return {
        type: SELECT_RESOURCE_POPULATED,
        payload: {
          stats,
          props
        }
      };
    })
  );



// WEBPACK FOOTER //
// ./src/components/map/ducks.js